import axios from "axios"
import accountApi from "../../api/account"
import utilsApi from "../../api/utils"
import profileApi from "@/api/profile"
import settings from "@/api/settings"
// general state for the eCommerce
const state = {
  user: {},
  account: {},
  logged: false,
  error: false,
  dataShape: [],
  account_extraInfo: {},
  extraInfo: {},
  new_user: null,
  alert: false,
  activeCities: [],
  activeCategories: [],
  kProfile: null,
}

const getters = {
  user: state => state.user,
  account: state => state.account,
  logged: state => state.logged,
  accountError: state => state.error,
  account_extraInfo: state => state.extraInfo,
  new_user: state => state.new_user,
  account_dataShape: state => state.dataShape,
  alert: state => state.alert,
  activeCities: state => state.activeCities,
  activeCategories: state => state.activeCategories,
  kCity: state => {
    if (state.kProfile == null) {
      return "PUTOOO"
    } else {
      const activeCity = state.activeCities.find(city => {
        return city._id === state.kProfile.city
      })
      console.log("ESTE ES EL ACTIVE CITY ", activeCity)
      if (activeCity == undefined) {
        return "HOLITA"
      } else {
        return activeCity.name
      }
    }
  },
  kCategory: state => {
    if (state.user != null) {
      if (state.kProfile == null) {
        return "NOOOO"
      } else {
        const activeCategory = state.activeCategories.find(city => {
          return city._id === state.kProfile.category
        })
        if (activeCategory == undefined) {
          return "NIPUEL"
        } else {
          return activeCategory.name
        }
      }
    } else {
      return "HOLITA"
    }
  },
  kProfile: state => {
    return state.kProfile
  },
}
const actions = {
  async ACTIVATE_PROFILE({ commit }, body) {
    // in colombian DB currency and value for plans may be wrong
    //work around
    console.log(body)

    const bodyU = Object.assign({}, body, {
      price: settings.getValue(body.price),
    })
    let apiResponse = await profileApi.activateAgencyP(bodyU)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PROFILES_SETTING", apiResponse)
      commit("CHANGE_K_SUCCES", apiResponse)

      return true
    } else {
      commit("PROFILES_ERROR")
      return false
    }
  },
  async DELETE_ACCOUNT({ commit }, body) {
    let apiResponse = await accountApi.deleteAccount(body)
    if (apiResponse != null) {
      return true
    } else {
      commit("LOG_IN_ERROR")
      return false
    }
  },
  async FETCH_activeObjects({ commit }) {
    let apiResponse = await utilsApi.getActiveObjects()
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("SET_ACTIVE_OBJECTS", apiResponse)
    } else {
      commit("GENERAL_ERROR")
    }
  },
  async NEW_PROFILE({ commit }) {
    let apiResponse = await accountApi.newProfile()
    if (apiResponse != null) {
      commit("CLEAN_K_SUCCESS")
      commit("NEW_PROFILE_SUCCES_account", apiResponse)
      // from profile module.
      commit("NEW_PROFILE_SUCCES_profile", apiResponse)
      return true
    } else {
      commit("NEW_PROFILE_ERROR")
      return false
    }
  },
  async CHANGE_K_PROFILE({ commit }, profileId) {
    let apiResponse = await accountApi.changeKProfile(profileId)
    if (apiResponse != null) {
      commit("CHANGE_K_SUCCES", apiResponse)
      // from profile module.
      commit("CHANGE_K_SUCCES_PROFILE", apiResponse)
      return true
    } else {
      commit("CHANGE_K_ERROR")
      return false
    }
  },
  async FETCH_account({ commit }) {
    let apiResponse = await utilsApi.getObjects("account")
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("ACCOUNT_SETTING", apiResponse)

      return true
    } else {
      commit("ACCOUNT_ERROR")
      return false
    }
  },
  async SAVE_account({ commit }, account) {
    let apiResponse = await utilsApi.saveObject("account", account)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("ACCOUNT_SETTING", apiResponse)
      commit("CHANGE_K_SUCCES", apiResponse)
      return true
    } else {
      commit("ACCOUNT_ERROR")
      return false
    }
  },
  async LOG_OUT({ commit, dispatch }) {
    localStorage.setItem("klausToken", null)
    axios.defaults.headers.common["Authorization"] = ""
    dispatch("CLEAN_profile")
    dispatch("CLEAN_places")
    commit("LOG_IN_ERROR", {})
  },
  async INIT_APP({ commit }) {
    // se verifica que en el localhost memoria tenga nuestro token,
    //si es asi,obtenemos el usuario.
    let preToken = localStorage.getItem("klausToken")

    console.log("PRETOKEN", preToken)
    // si exite un pretoken es un usuario que ya se habia registrado
    if (preToken) {
      const apiResponse = await accountApi.getUserWithToken(preToken)
      console.log("API RESPONSE", apiResponse)
      if (apiResponse != null) {
        commit("LOG_IN_OK", apiResponse)

        return true
      } else {
        //commit("LOG_IN_ERROR", {})
        return false
      }
    }
  },
  async LOG_IN({ commit }, credentials) {
    const apiResponse = await accountApi.logIn(
      credentials.username,
      credentials.pass
    )

    console.log("Apoi response", apiResponse)
    if (apiResponse != null) {
      localStorage.setItem("klausToken", apiResponse.auth_token)
      commit("LOG_IN_OK", apiResponse)
      return true
    } else {
      commit("LOG_IN_ERROR", {})
      return false
    }
  },
  async requestCODE({ commit }, credentials) {
    console.log(credentials)

    const apiResponse = await accountApi.requestCODE(
      credentials.phone,
      credentials.selected_country,
      credentials.reference,
      credentials.sms
    )

    console.log("Apoi response", apiResponse)
    if (apiResponse != null) {
      localStorage.setItem("klausToken", apiResponse.auth_token)
      commit("OKEY", apiResponse)
      return true
    } else {
      return false
    }
  },
  CHANGE_ALERT({ commit }, bool) {
    commit("CHANGE_ALERT", bool)
  },
}
const mutations = {
  NEW_PROFILE_SUCCES_account: (state, { user }) => {
    state.user = user
  },
  NEW_PROFILE_ERROR: state => {
    state.error = true
  },
  CLEAN_K_SUCCESS: state => {
    state.kProfile = {}
  },
  CHANGE_K_SUCCES: (state, { user }) => {
    state.user = user
    const Kprofiler = user.profiles.find(prof => {
      return prof._id === user.kProfile
    })
    console.log("ESTE ES EL K PROFILE", Kprofiler, user)
    state.kProfile = Kprofiler
  },
  CHANGE_K_ERROR: state => {
    state.error = true
  },
  ACCOUNT_SETTING: (state, { account, extraInfo, dataShape }) => {
    console.log(account, extraInfo, dataShape)
    state.account = account
    state.dataShape = dataShape
    state.extraInfo = extraInfo

    state.error = false
  },
  ACCOUNT_ERROR: state => {
    //state.user = null

    state.error = true
    state.dataShape = []
  },
  OKEY: (state, { new_user }) => {
    state.new_user = new_user
    state.error = false
  },
  LOG_IN_OK: (state, { user }) => {
    console.log("user", user)
    const Kprofiler = user.profiles.find(prof => {
      return prof._id === user.kProfile
    })
    console.log("ESTE ES EL K PROFILE", Kprofiler, user)
    state.kProfile = Kprofiler
    state.user = user
    state.logged = true
    state.error = false
  },
  LOG_IN_ERROR: (state, user) => {
    state.user = user
    state.logged = false
    state.error = true
  },
  SET_USER: (state, user) => {
    state.user = user
  },
  CHANGE_ALERT: (state, bool) => {
    state.alert = bool
  },
  SET_ACTIVE_OBJECTS: (state, status) => {
    state.activeCities = status.activeCities
    state.activeCategories = status.activeCategories
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
